<template>
  <div class="user-create-wrap">
    <a-form @submit="userCreateOk" :form="form">
      <a-card :bordered="false" style="box-shadow:0px 1px 10px 0px rgba(0,0,0,0.06);">
        <div class="info-title">
          学员信息
        </div>
        <div class="info-content" style="padding-top:25px;">
          <a-row >
            <a-col :span="24">
              <a-form-item
              style="margin-bottom:12px;"
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="学员名称">
                <a-input placeholder="请输入学员名称" v-decorator="['realName', {rules: [{ required: true, message: '请输入学员姓名' }]}]" />
              </a-form-item>
              </a-col>
          </a-row>
          <a-row >
            <a-col :span="24">
              <a-form-item
              style="margin-bottom:12px;"
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="英文名">
                <a-input placeholder="请输入英文名" v-decorator="['englishName', {rules: [{ required: true, message: '请输入学员英文名' }]}]" />
              </a-form-item>
              </a-col>
          </a-row>
          <a-row >
            <a-col :span="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="学员生日">
                <a-date-picker showTime format='YYYY-MM-DD' v-decorator="[ 'birthday', {rules: [{ required: true, message: '请输入学员生日' }]}]" />
              </a-form-item>
              </a-col>
          </a-row>
          <a-row >
            <a-col :span="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="性别">
                <j-dict-select-tag  v-decorator="['sex', {rules: [{ required: true, message: '请选择性别' }]} ]"
                 dictCode="sex" :triggerChange="true"/>
              </a-form-item>
              </a-col>
          </a-row>
          <a-row >
            <a-col :span="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="手机">
                <a-input placeholder="请输入手机" v-decorator="['phone', validatorRules.phone ]" />
              </a-form-item>
              </a-col>
          </a-row>
          <a-row >
            <a-col :span="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="签约/注册时间">
                <a-date-picker showTime format='YYYY-MM-DD HH:mm:ss' v-decorator="[ 'registerTime', {}]" />
              </a-form-item>
              </a-col>
          </a-row>
          <a-row >
            <a-col :span="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="过期时间">
                <a-date-picker showTime format='YYYY-MM-DD HH:mm:ss' v-decorator="[ 'expireTime', {}]" />
              </a-form-item>
              </a-col>
          </a-row>
          <a-row >
            <a-col :span="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="已付费">
                <a-input-number v-decorator="[ 'costValue', {}]" />
              </a-form-item> 
              </a-col>
          </a-row>
          <a-row >
            <a-col :span="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="所属校区">
                <a-input placeholder="请输入校区" v-decorator="['school', {rules: [{ required: false, message: '请输入学员校区' }]}]" />
              </a-form-item>
              </a-col>
          </a-row>
          <a-row >
            <a-col :span="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="所属班级">
                <a-input placeholder="请输入班级" v-decorator="['className', {rules: [{ required: false, message: '请输入学员所属班级' }]}]" />
              </a-form-item>
              </a-col>
          </a-row>
          <a-row >
            <a-col :span="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="上课内容">
                <a-input placeholder="上课内容" v-decorator="['classContent', {}]" />
              </a-form-item>
              </a-col>
          </a-row>
          <a-row >
            <a-col :span="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="来源">
                  <j-dict-select-tag  v-decorator="['source', {rules: [{ required: true, message: '请选择来源' }]}, ,{}]"
                 dictCode="user_source" :triggerChange="true"/>
              </a-form-item>
              </a-col>
          </a-row>
          <a-row >
            <a-col :span="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="上课时间">
                <a-date-picker showTime format='YYYY-MM-DD HH:mm:ss' v-decorator="[ 'classTime1', {}]" />
              </a-form-item>
              </a-col>
          </a-row>
        </div>
      </a-card>
      <a-card :bordered="false" style="text-align:center;padding:14px 0px;box-shadow:0px 1px 10px 0px rgba(0,0,0,0.06);">
        <div class="a-row">
          <a-button
          style="text-align:center;width:232px;line-height:40px;height:40px;font-size:14px;"
          type="primary"
          @click="userCreateOk()"
        >
          保存
        </a-button>
        </div>
      </a-card>
    </a-form>
  </div>
</template>

<script>
  import { httpAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import moment from "moment"
  import {getStudentById,studentAdd,studentUpdate,} from '@/api/api'

  export default {
    name: "StudentEdit",
    data () {
      return {
        title:"操作",
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 2 },
          sm: { span: 3 },
        },
        wrapperCol: {
          xs: { span: 4 },
          sm: { span: 6 },
        },
        form: this.$form.createForm(this),
        validatorRules:{
        phone:{rules: [{ required: true, message: '请输入手机号!' }]},
        },
        url: {
          add: "/userInfo/add",
          edit: "/userInfo/edit",
        },
      }
    },
    created () {
      let id = this.$route.query.id;
      if(id){
        getStudentById({"id":id}).then(res=>{
          
          if(res.success){
            this.model = Object.assign({}, res.result);
            this.edit(this.model);
          }
        });
      }else{
      }
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'realname','englishName','sex','phone','costValue','status','school','className','source'))
		      //时间格式化
          this.form.setFieldsValue({birthday:this.model.birthday?moment(this.model.birthday):null})
          this.form.setFieldsValue({registerTime:this.model.registerTime?moment(this.model.registerTime):null})
          this.form.setFieldsValue({classTime1:this.model.classTime1?moment(this.model.classTime1):null})
          this.form.setFieldsValue({expireTime:this.model.expireTime?moment(this.model.expireTime):null})
        });

      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      userCreateOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            //时间格式化
            formData.birthday = formData.birthday?formData.birthday.format('YYYY-MM-DD'):null;
            formData.registerTime = formData.registerTime?formData.registerTime.format('YYYY-MM-DD HH:mm:ss'):null;
            formData.expireTime = formData.expireTime?formData.expireTime.format('YYYY-MM-DD HH:mm:ss'):null;
            formData.classTime1 = formData.classTime1?formData.classTime1.format('YYYY-MM-DD HH:mm:ss'):null;

            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
                 this.$router.push({ path:'/studentManagement/StudentList'})
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }
        })
      },
      handleCancel () {
        this.close()
      },
    }
  }
</script>

<style lang="less" scoped>
.user-create-wrap{
    .info-title{
      border-bottom: 1px solid #E7ECEF;
      line-height: 50px;
      height: 50px;
      padding-left: 25px;
    }
  }
</style>